import { mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { EMPTY, of, concat } from 'rxjs';
import * as OrdersNavAction from '../../../store/orders/nav/orders.nav.actions';
import Global from '../../../store/global-selectors';
import * as Actions from './alerts.nav.actions';
import { ORDER_ALERTS_ID, ORDER_ALERTS_SHIP_TOGETHER_ID } from '../../../pages/orders-page/orders-page-view-constants';
import { getSelectedViewFromPathName } from '../../../pages/orders-page/orders-left-nav/orders-left-nav-context';

export const ordersViewsChangedEpic = (action$, { getState }, { history }) =>
  action$.pipe(
    ofType(Actions.ALERTS_UPDATE_ORDERS_PAGE_LEFT_NAV),
    mergeMap(() => {
      const stores = Global.selectSellerActiveStores(getState());
      const statusViewId = getSelectedViewFromPathName(history?.location?.pathname, stores)?.id;

      if (statusViewId !== ORDER_ALERTS_ID && statusViewId !== ORDER_ALERTS_SHIP_TOGETHER_ID) {
        return concat(of(OrdersNavAction.clearSearchInput()));
      }
      return EMPTY;
    }),
  );
